// src/views/contasBancarias/ContaBancariaModal.jsx
import React, { useState, useEffect } from "react";
import contasBancariasService from "../../services/contasBancariasService";
import contasContabeisService from "../../services/contasContabeisService";

const BANCOS = [
  {value:"BancoDoBrasil", label:"Banco do Brasil",  codigo:"001"},
  {value:"Bradesco",      label:"Bradesco",          codigo:"237"},
  {value:"Itau",          label:"Itaú",              codigo:"341"},
  {value:"Caixa",         label:"Caixa Econômica",   codigo:"104"},
  {value:"Santander",     label:"Santander",         codigo:"033"},
  {value:"Sicredi",       label:"Sicredi",           codigo:"748"},
  {value:"Sicoob",        label:"Sicoob",            codigo:"756"},
  {value:"EFI",           label:"EFÍ Bank (Gerencianet)", codigo:"364"},
  {value:"Inter",         label:"Banco Inter",       codigo:"077"},
  {value:"Nubank",        label:"Nubank",            codigo:"260"},
  {value:"Outro",         label:"Outro",             codigo:""},
];

const EMPTY_CONTA = {
  nmConta:"", tpConta:"ContaCorrente", banco:"", codBanco:"",
  agencia:"", dgAgencia:"", contaCorrente:"", dgConta:"", chavePix:"",
  saldoInicial:"0.00", dtSaldoInicial:"", idContaContabil:"",
  situacao:"ativo", observacao:"",
};

const EMPTY_BOLETO = {
  bancoBoleto:"Bradesco", nmCedente:"", cnpjCedente:"", carteira:"", codigoCedente:"",
  convenio:"", variacaoCarteira:"", nossoNumeroInicial:"1", nossoNumeroAtual:null,
  ambiente:"Homologacao", urlApiHomologacao:"", urlApiProducao:"",
  clientId:"", clientSecret:"", webhookUrl:"",
  diasExpiracao:"3", aceite:"N", especieDoc:"DM",
  instrucao1:"", instrucao2:"", mensagemPagador:"",
  tpMulta:"Percentual", vlrMulta:"2.0000",
  tpJuro:"DiaSeguinte", vlrJuroDia:"1.0000",
  tpDesconto:"Isento", vlrDesconto:"0.0000", diasDesconto:"",
  ativo:1,
};

const fmtCEP = v => { const d=v.replace(/\D/g,"").slice(0,8); return d.replace(/^(\d{5})(\d)/,"$1-$2"); };

export default function ContaBancariaModal({ show, onClose, onSave, editData, saving=false, idCondominio, condominioNome="" }) {
  const isEdit = !!editData?.id;
  const [form, setForm]         = useState(EMPTY_CONTA);
  const [formBoleto, setFormBoleto] = useState(EMPTY_BOLETO);
  const [errors, setErrors]     = useState({});
  const [tab, setTab]           = useState("dados");
  const [contasContabeis, setContasContabeis] = useState([]);
  const [savingBoleto, setSavingBoleto] = useState(false);
  const [showSenha, setShowSenha] = useState(false);

  useEffect(() => {
    if (!idCondominio) return;
    contasContabeisService.listar({ idCondominio, situacao:"ativo", natureza:"Analitica" })
      .then(r => setContasContabeis(r.data || [])).catch(()=>{});
  }, [idCondominio]);

  useEffect(() => {
    if (!show) return;
    setForm(editData ? { ...EMPTY_CONTA, ...editData } : { ...EMPTY_CONTA });
    setErrors({}); setTab("dados");
    if (editData?.id) {
      contasBancariasService.buscarConfigBoleto(editData.id)
        .then(r => { if (r.data) setFormBoleto({ ...EMPTY_BOLETO, ...r.data }); else setFormBoleto(EMPTY_BOLETO); })
        .catch(()=>{});
    } else { setFormBoleto(EMPTY_BOLETO); }
  }, [show, editData]);

  const set = (f,v) => { setForm(p=>({...p,[f]:v})); setErrors(p=>({...p,[f]:undefined})); };
  const setB = (f,v) => setFormBoleto(p=>({...p,[f]:v}));

  const handleBancoChange = (value) => {
    const banco = BANCOS.find(b=>b.value===value);
    setForm(p=>({...p,banco:banco?.label||"",codBanco:banco?.codigo||""}));
    setFormBoleto(p=>({...p,bancoBoleto:value}));
  };

  const validate = () => {
    const e={};
    if(!form.nmConta.trim()) e.nmConta="Nome da conta é obrigatório";
    setErrors(e); if(Object.keys(e).length){setTab("dados");return false;} return true;
  };

  const handleSave = () => { if(validate()) onSave({...form, id:editData?.id}); };

  const handleSaveBoleto = async () => {
    if (!editData?.id) return alert("Salve a conta primeiro.");
    setSavingBoleto(true);
    try {
      await contasBancariasService.salvarConfigBoleto(editData.id, formBoleto);
      alert("Configuração de boleto salva com sucesso!");
    } catch(e) { alert(e.message); }
    setSavingBoleto(false);
  };

  if (!show) return null;

  const tabs = [
    { id:"dados",    label:"Dados da Conta",     icon:"bi-bank2" },
    { id:"boleto",   label:"Config. Boleto",      icon:"bi-receipt-cutoff" },
    { id:"api",      label:"API / Segurança",     icon:"bi-shield-lock" },
  ];

  const dtSaldoInicial = form.dtSaldoInicial?.includes("T") ? form.dtSaldoInicial.split("T")[0] : form.dtSaldoInicial;

  return (
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className="bi bi-bank" style={{fontSize:18,color:"#fff"}}/>
              </div>
              <div>
                <h5 className="modal-title mb-0">{isEdit?"Editar Conta Bancária":"Nova Conta Bancária"}</h5>
                <small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>{condominioNome}</small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>

          <div style={{background:"var(--primary)",padding:"0 24px"}}>
            <ul className="nav nav-tabs border-0" style={{gap:4}}>
              {tabs.map(t=>(
                <li key={t.id} className="nav-item">
                  <button className={`nav-link border-0 d-flex align-items-center gap-2 ${tab===t.id?"active":""}`}
                    style={{background:tab===t.id?"#fff":"transparent",color:tab===t.id?"var(--primary)":"rgba(255,255,255,.7)",borderRadius:"6px 6px 0 0",fontFamily:"Poppins,sans-serif",fontSize:13,fontWeight:500,padding:"10px 18px"}}
                    onClick={()=>setTab(t.id)}>
                    <i className={`bi ${t.icon}`}/>{t.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-body">

            {/* ── DADOS DA CONTA ── */}
            {tab==="dados" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-bank2"/> Identificação</div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Nome da Conta <span className="required-mark">*</span></label>
                      <input className={`form-control ${errors.nmConta?"is-invalid":""}`} value={form.nmConta} onChange={e=>set("nmConta",e.target.value)} placeholder="Ex: Conta Principal BB, Fundo de Reserva..."/>
                      {errors.nmConta&&<div className="invalid-feedback">{errors.nmConta}</div>}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Tipo de Conta</label>
                      <select className="form-select" value={form.tpConta} onChange={e=>set("tpConta",e.target.value)}>
                        <option value="ContaCorrente">Conta Corrente</option>
                        <option value="Poupanca">Poupança</option>
                        <option value="CaixaInterno">Caixa Interno</option>
                        <option value="Investimento">Investimento</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Situação</label>
                      <select className="form-select" value={form.situacao} onChange={e=>set("situacao",e.target.value)}>
                        <option value="ativo">Ativa</option>
                        <option value="inativo">Inativa</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-building-fill"/> Dados Bancários</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Banco</label>
                      <select className="form-select" value={BANCOS.find(b=>b.label===form.banco)?.value||"Outro"} onChange={e=>handleBancoChange(e.target.value)}>
                        {BANCOS.map(b=><option key={b.value} value={b.value}>{b.codigo?`${b.codigo} - `:""}  {b.label}</option>)}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Cód. COMPE</label>
                      <input className="form-control" value={form.codBanco} onChange={e=>set("codBanco",e.target.value)} placeholder="001"/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Agência</label>
                      <input className="form-control" value={form.agencia} onChange={e=>set("agencia",e.target.value)} placeholder="0000"/>
                    </div>
                    <div className="col-md-1">
                      <label className="form-label">Dígito</label>
                      <input className="form-control" value={form.dgAgencia} onChange={e=>set("dgAgencia",e.target.value)} placeholder="X"/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Conta Corrente</label>
                      <input className="form-control" value={form.contaCorrente} onChange={e=>set("contaCorrente",e.target.value)} placeholder="000000"/>
                    </div>
                    <div className="col-md-1">
                      <label className="form-label">Dígito</label>
                      <input className="form-control" value={form.dgConta} onChange={e=>set("dgConta",e.target.value)} placeholder="X"/>
                    </div>
                    <div className="col-md-5">
                      <label className="form-label">Chave PIX</label>
                      <input className="form-control" value={form.chavePix} onChange={e=>set("chavePix",e.target.value)} placeholder="CPF, CNPJ, e-mail, telefone ou chave aleatória"/>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-cash-coin"/> Saldo e Vínculo Contábil</div>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">Saldo Inicial (R$)</label>
                      <div className="input-group">
                        <span className="input-group-text">R$</span>
                        <input className="form-control" type="number" step="0.01" value={form.saldoInicial} onChange={e=>set("saldoInicial",e.target.value)}/>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Data do Saldo Inicial</label>
                      <input type="date" className="form-control" value={dtSaldoInicial||""} onChange={e=>set("dtSaldoInicial",e.target.value)}/>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Conta Contábil Vinculada</label>
                      <select className="form-select" value={form.idContaContabil} onChange={e=>set("idContaContabil",e.target.value)}>
                        <option value="">— Sem vínculo —</option>
                        {contasContabeis.filter(c=>["Banco","Caixa","AtivoCirculante"].includes(c.tpConta)).map(c=>(
                          <option key={c.id} value={c.id}>{c.classificacaoContabil} — {c.descConta}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Observações</label>
                      <textarea className="form-control" rows={2} value={form.observacao} onChange={e=>set("observacao",e.target.value)}/>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* ── CONFIG BOLETO ── */}
            {tab==="boleto" && (
              <>
                {!isEdit && (
                  <div style={{background:"#FFF7ED",border:"1px solid #FED7AA",borderRadius:8,padding:"12px 16px",marginBottom:14,fontSize:13,color:"#C2410C"}}>
                    <i className="bi bi-exclamation-triangle me-2"/>Salve a conta primeiro para configurar o boleto.
                  </div>
                )}
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-receipt-cutoff"/> Cedente / Beneficiário</div>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Banco do Boleto</label>
                      <select className="form-select" value={formBoleto.bancoBoleto} onChange={e=>setB("bancoBoleto",e.target.value)}>
                        {BANCOS.filter(b=>b.value!=="Outro").map(b=><option key={b.value} value={b.value}>{b.label}</option>)}
                        <option value="Outro">Outro</option>
                      </select>
                    </div>
                    <div className="col-md-5">
                      <label className="form-label">Nome do Cedente</label>
                      <input className="form-control" value={formBoleto.nmCedente} onChange={e=>setB("nmCedente",e.target.value)} placeholder="Razão social do condomínio"/>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">CNPJ do Cedente</label>
                      <input className="form-control" value={formBoleto.cnpjCedente} onChange={e=>setB("cnpjCedente",e.target.value)} placeholder="00.000.000/0001-00"/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Carteira</label>
                      <input className="form-control" value={formBoleto.carteira} onChange={e=>setB("carteira",e.target.value)} placeholder="17, 09, SR..."/>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Código do Cedente</label>
                      <input className="form-control" value={formBoleto.codigoCedente} onChange={e=>setB("codigoCedente",e.target.value)}/>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Convênio</label>
                      <input className="form-control" value={formBoleto.convenio} onChange={e=>setB("convenio",e.target.value)}/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Variação Carteira</label>
                      <input className="form-control" value={formBoleto.variacaoCarteira} onChange={e=>setB("variacaoCarteira",e.target.value)}/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Nosso Nº Inicial</label>
                      <input className="form-control" type="number" value={formBoleto.nossoNumeroInicial} onChange={e=>setB("nossoNumeroInicial",e.target.value)}/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Próximo Nosso Nº</label>
                      <input className="form-control" type="number"
                        value={formBoleto.nossoNumeroAtual||formBoleto.nossoNumeroInicial||1}
                        readOnly style={{background:"var(--bg-page)",color:"var(--gray-600)",cursor:"not-allowed"}}/>
                      <small className="text-muted" style={{fontSize:10}}>Atualizado a cada geração</small>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-sliders"/> Parâmetros do Boleto</div>
                  <div className="row g-3">
                    <div className="col-md-2">
                      <label className="form-label">Dias p/ Expirar</label>
                      <input className="form-control" type="number" min="1" value={formBoleto.diasExpiracao} onChange={e=>setB("diasExpiracao",e.target.value)}/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Aceite</label>
                      <select className="form-select" value={formBoleto.aceite} onChange={e=>setB("aceite",e.target.value)}>
                        <option value="N">Não</option><option value="S">Sim</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Espécie Doc.</label>
                      <select className="form-select" value={formBoleto.especieDoc} onChange={e=>setB("especieDoc",e.target.value)}>
                        <option value="DM">DM - Duplicata</option>
                        <option value="RC">RC - Recibo</option>
                        <option value="NP">NP - Nota Promissória</option>
                        <option value="NS">NS - Nota de Serviço</option>
                        <option value="OU">OU - Outros</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Instrução 1</label>
                      <input className="form-control" value={formBoleto.instrucao1} onChange={e=>setB("instrucao1",e.target.value)} placeholder="Ex: Não receber após 5 dias do vencimento"/>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Instrução 2</label>
                      <input className="form-control" value={formBoleto.instrucao2} onChange={e=>setB("instrucao2",e.target.value)} placeholder="Ex: Cobrar multa de 2% após vencimento"/>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Mensagem ao Pagador</label>
                      <input className="form-control" value={formBoleto.mensagemPagador} onChange={e=>setB("mensagemPagador",e.target.value)} placeholder="Ex: Referente à cota condominial"/>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-percent"/> Multa, Juros e Desconto</div>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">Tipo de Multa</label>
                      <select className="form-select" value={formBoleto.tpMulta} onChange={e=>setB("tpMulta",e.target.value)}>
                        <option value="Isento">Isento</option>
                        <option value="Percentual">Percentual (%)</option>
                        <option value="ValorFixo">Valor Fixo (R$)</option>
                      </select>
                    </div>
                    {formBoleto.tpMulta!=="Isento"&&<div className="col-md-2">
                      <label className="form-label">{formBoleto.tpMulta==="Percentual"?"Multa (%)":"Multa (R$)"}</label>
                      <input className="form-control" type="number" step="0.0001" value={formBoleto.vlrMulta} onChange={e=>setB("vlrMulta",e.target.value)}/>
                    </div>}
                    <div className="col-md-3">
                      <label className="form-label">Tipo de Juro</label>
                      <select className="form-select" value={formBoleto.tpJuro} onChange={e=>setB("tpJuro",e.target.value)}>
                        <option value="Isento">Isento</option>
                        <option value="DiaSeguinte">Dia Seguinte</option>
                        <option value="Mensal">Mensal</option>
                      </select>
                    </div>
                    {formBoleto.tpJuro!=="Isento"&&<div className="col-md-2">
                      <label className="form-label">Juro ao Dia (%)</label>
                      <input className="form-control" type="number" step="0.0001" value={formBoleto.vlrJuroDia} onChange={e=>setB("vlrJuroDia",e.target.value)}/>
                    </div>}
                    <div className="col-md-3">
                      <label className="form-label">Tipo de Desconto</label>
                      <select className="form-select" value={formBoleto.tpDesconto} onChange={e=>setB("tpDesconto",e.target.value)}>
                        <option value="Isento">Isento</option>
                        <option value="Percentual">Percentual (%)</option>
                        <option value="ValorFixo">Valor Fixo (R$)</option>
                      </select>
                    </div>
                    {formBoleto.tpDesconto!=="Isento"&&<>
                      <div className="col-md-2">
                        <label className="form-label">{formBoleto.tpDesconto==="Percentual"?"Desconto (%)":"Desconto (R$)"}</label>
                        <input className="form-control" type="number" step="0.0001" value={formBoleto.vlrDesconto} onChange={e=>setB("vlrDesconto",e.target.value)}/>
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Dias Antecedência</label>
                        <input className="form-control" type="number" min="0" value={formBoleto.diasDesconto} onChange={e=>setB("diasDesconto",e.target.value)}/>
                      </div>
                    </>}
                  </div>
                </div>

                {isEdit&&<div className="d-flex justify-content-end mt-2">
                  <button className="btn btn-success" onClick={handleSaveBoleto} disabled={savingBoleto}>
                    {savingBoleto?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>:<><i className="bi bi-check-circle"/> Salvar Config. Boleto</>}
                  </button>
                </div>}
              </>
            )}

            {/* ── API / SEGURANÇA ── */}
            {tab==="api" && (
              <>
                {!isEdit&&<div style={{background:"#FFF7ED",border:"1px solid #FED7AA",borderRadius:8,padding:"12px 16px",marginBottom:14,fontSize:13,color:"#C2410C"}}><i className="bi bi-exclamation-triangle me-2"/>Salve a conta primeiro.</div>}
                <div style={{background:"var(--bg-highlight)",border:"1px solid #BFDBFE",borderRadius:8,padding:"10px 14px",marginBottom:14,fontSize:12.5,color:"var(--primary)"}}>
                  <i className="bi bi-info-circle me-2"/>
                  <strong>Esta aba é opcional</strong> e armazena credenciais legadas (algumas integrações usam estes campos como fallback).
                  Para configurar a API OAuth principal (Sicoob/EFI), feche este modal e use a aba <strong>"Integração API"</strong> da tela principal.
                </div>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-shield-lock"/> Credenciais da API (legado)</div>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">Ambiente</label>
                      <select className="form-select" value={formBoleto.ambiente} onChange={e=>setB("ambiente",e.target.value)}>
                        <option value="Homologacao">Homologação</option>
                        <option value="Producao">Produção</option>
                      </select>
                    </div>
                    <div className="col-md-9">
                      <label className="form-label">URL API Homologação</label>
                      <input className="form-control" value={formBoleto.urlApiHomologacao} onChange={e=>setB("urlApiHomologacao",e.target.value)} placeholder="https://sandbox.api.banco.com.br/..."/>
                    </div>
                    <div className="col-md-12">
                      <label className="form-label">URL API Produção</label>
                      <input className="form-control" value={formBoleto.urlApiProducao} onChange={e=>setB("urlApiProducao",e.target.value)} placeholder="https://api.banco.com.br/..."/>
                    </div>
                    <div className="col-md-5">
                      <label className="form-label">Client ID</label>
                      <input className="form-control" value={formBoleto.clientId||""} onChange={e=>setB("clientId",e.target.value)} placeholder="Client ID da aplicação"/>
                    </div>
                    <div className="col-md-5">
                      <label className="form-label">Client Secret</label>
                      <div className="input-group">
                        <input className="form-control" type={showSenha?"text":"password"} value={formBoleto.clientSecret||""}
                          onChange={e=>setB("clientSecret",e.target.value)}
                          placeholder={formBoleto.clientSecretHint ? `${formBoleto.clientSecretHint}●●●●●●●● (deixe vazio para manter)` : "Client Secret"}
                          autoComplete="new-password"/>
                        <button className="btn btn-outline-secondary" type="button" onClick={()=>setShowSenha(p=>!p)}>
                          <i className={`bi bi-eye${showSenha?"-slash":""}`}/>
                        </button>
                      </div>
                      {formBoleto.clientSecretHint && (
                        <small className="text-muted" style={{fontSize:11}}>
                          <i className="bi bi-shield-check me-1" style={{color:"#10B981"}}/>
                          Já cadastrado e criptografado.
                        </small>
                      )}
                    </div>
                    <div className="col-md-12">
                      <label className="form-label">Webhook URL (retorno de pagamento)</label>
                      <input className="form-control" value={formBoleto.webhookUrl} onChange={e=>setB("webhookUrl",e.target.value)} placeholder="https://seuservidor.com.br/api/contas-bancarias/{id}/boleto/webhook"/>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-file-earmark-lock"/> Certificado Digital</div>
                  <div className="row g-3">
                    <div className="col-md-12">
                      <label className="form-label">Certificado (Base64)</label>
                      <textarea className="form-control" rows={4} value={formBoleto.certificadoBase64||""}
                        onChange={e=>setB("certificadoBase64",e.target.value)}
                        placeholder={formBoleto.certificadoBase64Hint
                          ? `Certificado já cadastrado (${formBoleto.certificadoBase64Hint}…) — deixe vazio para manter`
                          : "Cole aqui o conteúdo do certificado .p12 em Base64..."}/>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>
                        Converta o arquivo .p12 para Base64 antes de colar. Ex: base64 -i certificado.p12
                        {formBoleto.certificadoBase64Hint && <> · <i className="bi bi-shield-check" style={{color:"#10B981"}}/> Criptografado em repouso.</>}
                      </small>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Senha do Certificado</label>
                      <input className="form-control" type="password" value={formBoleto.senhaCertificado||""}
                        onChange={e=>setB("senhaCertificado",e.target.value)}
                        placeholder={formBoleto.senhaCertificadoHint ? "(já cadastrada — deixe vazio)" : "Senha do .p12"}
                        autoComplete="new-password"/>
                    </div>
                  </div>
                </div>

                <div style={{background:"var(--bg-success-soft)",border:"1px solid #BBF7D0",borderRadius:8,padding:"12px 16px",fontSize:12.5,color:"#166534"}}>
                  <i className="bi bi-info-circle me-2"/>
                  <strong>Nota de integração:</strong> Os endpoints preparados são: <code>POST /boleto/gerar</code>, <code>GET /boleto/consultar/:nossoNumero</code> e <code>POST /boleto/webhook</code>. Para cada banco, implemente a chamada HTTP específica no controller usando as credenciais acima.
                </div>

                {isEdit&&<div className="d-flex justify-content-end mt-3">
                  <button className="btn btn-success" onClick={handleSaveBoleto} disabled={savingBoleto}>
                    {savingBoleto?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>:<><i className="bi bi-check-circle"/> Salvar Credenciais</>}
                  </button>
                </div>}
              </>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div style={{fontSize:12,color:"var(--gray-400)"}}><i className="bi bi-asterisk me-1" style={{color:"#ef4444",fontSize:9}}/>Campos obrigatórios</div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle"/> Cancelar</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                {saving?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>:<><i className="bi bi-check-circle"/> {isEdit?"Salvar Alterações":"Cadastrar"}</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
